import { createAction } from 'redux-actions';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const UPDATE_MODAL = 'UPDATE_MODAL';

const openModal = createAction(OPEN_MODAL);
const closeModal = createAction(CLOSE_MODAL);
const updateModal = createAction(UPDATE_MODAL);

export default {
    openModal,
    closeModal,
    updateModal
};



// WEBPACK FOOTER //
// ./containers/modal-container/modal-actions.js